import React, { createContext, useState } from 'react'

export const StepHandlerContext = createContext({
  previousStep: () => {},
  setPreviousStep: () => {},
  nextStep: () => {},
  setNextStep: () => {}
})

export const StepHandlerProvider = ({ children }) => {
  const [previousStep, setPreviousStep] = useState(() => {})
  const [nextStep, setNextStep] = useState(() => {})
  const value = {
    previousStep,
    setPreviousStep,
    nextStep,
    setNextStep
  }

  return (
    <StepHandlerContext.Provider value={value}>
      {children}
    </StepHandlerContext.Provider>
  )
}
